import "./Weather.css";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemp from "./WeatherTemp";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  return (
    <div className="Weather">
      <div className="weather-today">
        <div className="info">
          <h1 className="city">{props.data.city}</h1>
          <FormattedDate date={props.data.date} />
        </div>
        <div className="cityWeather">
          <div className="icon-temp">
            <WeatherIcon
              icon={props.data.icon}
              size={130}
              color="rgb(21, 54, 133)"
            />
            <div className="temp">
              <WeatherTemp temperature={props.data.temperature} />
            </div>
          </div>
          <div className="descrip-hum-wind">
            <div className="description text-capitalize">
              {props.data.description}
            </div>
            <div>
              <i className="fas fa-tint"></i> {props.data.humidity}%{" "}
            </div>
            <div>
              <i className="fas fa-wind"></i> {props.data.wind} m/s
            </div>
          </div>
        </div>
      </div>
      <WeatherForecast coord={props.data.coord} />
    </div>
  );
}
